import { render } from "./ProgramPage.vue?vue&type=template&id=c05c95ae&scoped=true"
import script from "./ProgramPage.vue?vue&type=script&lang=js"
export * from "./ProgramPage.vue?vue&type=script&lang=js"

import "./ProgramPage.vue?vue&type=style&index=0&id=c05c95ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c05c95ae"]])

export default __exports__